module.exports = __webpack_public_path__ + "img/secure-human.0f14867b.svg";